'use client';

import { Suspense } from 'react';
import { useGoogleAnalytics } from '@/lib/analytics';

function AnalyticsTracker() {
  useGoogleAnalytics();
  return null;
}

export default function GoogleAnalytics() {
  return (
    <Suspense fallback={null}>
      <AnalyticsTracker />
    </Suspense>
  );
}
